import _merge from 'lodash/merge';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { identity } from 'lodash';
import { makeDefaultStylingContext } from '../utils/style';
import {
  FILL_UNFOCUSED_COLOR,
  FILL_FOCUSED_COLOR,
  TEXT_COLOR,
  TEXT_SELECTED_COLOR,
  FILL_SELECTED_COLOR,
  STROKE_COLOR,
  INNER_COLOR,
} from './facet.constants';
import { TRANSPARENT } from '../utils/colors';

export const defaultContext = makeDefaultStylingContext();

export const HEIGHT = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const PADDING = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const ICON_WIDTH = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const ICON_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const GAP = {
  [HD]: 4,
  [FULL_HD]: 8,
};

export const BORDER_WIDTH = {
  [HD]: 4,
  [FULL_HD]: 6,
};

export const getUnFocusedStyle = ({ colorMode }, selected = false) => ({
  Fill: {
    color: selected ? FILL_SELECTED_COLOR[colorMode] : FILL_UNFOCUSED_COLOR[colorMode],
  },
  Background: {
    shader: {
      strokeColor: TRANSPARENT,
      innerColor: TRANSPARENT,
    },
  },
  Icon: {
    color: selected ? TEXT_SELECTED_COLOR[colorMode] : TEXT_COLOR[colorMode],
  },
  Label: {
    color: selected ? TEXT_SELECTED_COLOR[colorMode] : TEXT_COLOR[colorMode],
  },
});

export const getFocusedStyle = ({ colorMode }, selected = false) => ({
  Fill: {
    color: selected ? FILL_SELECTED_COLOR[colorMode] : FILL_FOCUSED_COLOR[colorMode],
  },
  Background: {
    shader: {
      strokeColor: selected ? STROKE_COLOR[colorMode] : TRANSPARENT,
      innerColor: selected ? INNER_COLOR[colorMode] : TRANSPARENT,
    },
  },
  Icon: {
    color: selected ? TEXT_SELECTED_COLOR[colorMode] : TEXT_COLOR[colorMode],
  },
  Label: {
    color: selected ? TEXT_SELECTED_COLOR[colorMode] : TEXT_COLOR[colorMode],
  },
});

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const h = HEIGHT[screenSize];
  const font = getFont(FONT.OTTAWA_2, screenSize);
  const offset = Math.round(BORDER_WIDTH[screenSize] / 2);

  return _merge(
    {
      h,
      Fill: {
        w: identity,
        h,
        rect: true,
        shader: {
          radius: Math.round((HEIGHT[screenSize] - BORDER_WIDTH[screenSize]) / 2),
        },
        color: FILL_UNFOCUSED_COLOR[colorMode],
      },
      Background: {
        x: -offset,
        y: -offset,
        rect: true,
        w: v => v + BORDER_WIDTH[screenSize],
        h: v => v + BORDER_WIDTH[screenSize],
        color: TRANSPARENT,
        shader: {
          useImageMask: true,
          strokeColor: TRANSPARENT,
          innerColor: INNER_COLOR[colorMode],
          outline: BORDER_WIDTH[screenSize],
          radius: Math.round(HEIGHT[screenSize] / 2),
          scale: 1,
        },
      },
      Icon: {
        y: Math.round((h - ICON_HEIGHT[screenSize]) / 2),
        iconData: {
          picto: { name: 'Cross' },
          viewBox: {
            w: ICON_WIDTH[screenSize],
            h: ICON_HEIGHT[screenSize],
          },
        },
      },
      Label: {
        y: Math.round((h - font.lineHeight) / 2),
        text: {
          ...font,
          verticalAlign: 'middle',
        },
      },
    },
    getUnFocusedStyle(context),
  );
};
